export default (input) => {
  return {
    ...input,
    gutter: input.gutter?.toString()
  };
};
